import { Element } from '@craftjs/core'
import {
  TextEditor,
  Text,
  Button,
  Image,
  Video,
  BoxLink,
  TextImageBox,
  CircleBox,
  Row,
  Col,
  ListImageBox,
  ListImageBoxItem,
  ListIconBox,
  ListIconBoxItem,
  CopertinaBox,
  SimpleBox,
  CustomCode,
  RowIcons,
  TextImageBoxWithIcons,
  EcosistemaImage,
} from '../../../../components'
import {
  Text as TextIcon,
  Button as ButtonIcon,
  Image as ImageIcon,
  Video as VideoIcon,
} from '../../../../pb-components/icons'

/* export const BOXLIST = (
  <Element is={BoxList} canvas></Element>
); */

export const ROW2COL = (
  <Element canvas is={Row}>
    <Element canvas is={Col}></Element>
    <Element canvas is={Col}></Element>
  </Element>
)
export const COL = <Element canvas is={Col}></Element>

export const TEXT = (
  <Element is={Text}>
    <TextEditor
      block={{
        text: '<p>Hello world!</p>',
        className: 'text__content',
      }}
    />
  </Element>
)

export const BUTTON = (
  <Element is={Button}>
    <TextEditor
      block={{
        text: 'Click me',
        noHtml: true,
      }}
    />
  </Element>
)

export const IMAGE = <Image block={{ src: 'https://via.placeholder.com/800x600.png' }} />

export const VIDEO = <Video block={{ src: '' }} />

export const SIMPLE_BOX = (
  <Element is={SimpleBox}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
    <TextEditor
      block={{
        text: '<p>Lorem ipsum...</p>',
      }}
    />
  </Element>
)

export const BOX_LINK = (
  <Element is={BoxLink}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
  </Element>
)

export const TEXT_IMAGE_BOX = (
  <Element is={TextImageBox}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
    <TextEditor
      block={{
        text: '<p>Descrizione</p>',
      }}
    />
  </Element>
)

export const CIRCLE_BOX = (
  <Element is={CircleBox}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
    <TextEditor
      block={{
        text: '<p>Descrizione</p>',
      }}
    />
  </Element>
)

export const LIST_IMAGE_BOX = (
  <Element canvas is={ListImageBox}>
    <Element is={ListImageBoxItem}>
      <TextEditor
        block={{
          text: 'Titolo',
          noHtml: true,
        }}
      />
      <TextEditor
        block={{
          text: '<p>Descrizione</p>',
        }}
      />
    </Element>
  </Element>
)

export const LIST_ICON_BOX = (
  <Element canvas is={ListIconBox}>
    <Element is={ListIconBoxItem}>
      <TextEditor
        block={{
          text: 'Titolo',
          noHtml: true,
        }}
      />
    </Element>
  </Element>
)

export const COPERTINA_BOX = (
  <Element is={CopertinaBox}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
    <TextEditor
      block={{
        text: 'Lorem ipsum...',
      }}
    />
  </Element>
)

export const ROW_ICONS = (
  <Element canvas is={RowIcons}>
    <Element is={ListIconBoxItem}>
      <TextEditor
        block={{
          text: 'Titolo',
          noHtml: true,
        }}
      />
    </Element>
  </Element>
)

export const TEXT_IMAGE_BOX_WITH_ICONS = (
  <Element is={TextImageBoxWithIcons}>
    <TextEditor
      block={{
        text: 'Titolo',
        noHtml: true,
      }}
    />
    <TextEditor
      block={{
        text: '<p>Descrizione</p>',
      }}
    />
    <Element canvas is={RowIcons}>
      <Element is={ListIconBoxItem}>
        <TextEditor
          block={{
            text: 'Titolo icona',
            noHtml: true,
          }}
        />
      </Element>
    </Element>
  </Element>
)

export const TEXT_ICON = (
  <Element is={ListIconBoxItem}>
    <TextEditor
      block={{
        text: 'Titolo icona',
        noHtml: true,
      }}
    />
  </Element>
)

export const MOBILITY_IMAGE = <Element is={EcosistemaImage}></Element>

/* export const QUOTEBOX = (
  <Element is={QuoteBox}>
    <TextEditor block={{
      text: 'Titolo',
      noHtml: true
    }} />
    <TextEditor block={{
      text: '<p>Lorem ipsum...</p>',
    }} />
  </Element>
); */

/* export const LINKBOX = (
  <Element is={LinkBox}>
    <TextEditor block={{
      text: 'Titolo',
      noHtml: true
    }} />
    <TextEditor block={{
      text: '<p>Lorem ipsum...</p>',
    }} />
    <TextEditor block={{
      text: 'Cta',
      noHtml: true
    }} />
  </Element>
); */

/* export const ACTIVITYCARD = (
  <Element is={ActivityCard}>
    <TextEditor block={{
      text: 'Attività #',
      noHtml: true
    }} />
    <TextEditor block={{
      text: '<p>Lorem ipsum...</p>',
    }} />
    <TextEditor block={{
      text: 'Leggi l\'articolo',
      noHtml: true
    }} />
  </Element>
); */

export const CUSTOM_CODE = <CustomCode />

// possibilità di inserire icona per il block
export const conf = [
  {
    title: 'Layout',
    blocks: {
      row2col: {
        name: '2 Colonne',
        block: ROW2COL,
      },
    },
  },
  {
    title: 'Basic',
    blocks: {
      text: {
        name: 'Text',
        icon: <TextIcon />,
        block: TEXT,
      },
      button: {
        name: 'Button',
        icon: <ButtonIcon />,
        block: BUTTON,
      },
      image: {
        name: 'Image',
        icon: <ImageIcon />,
        block: IMAGE,
      },
      /*video: {
        name: 'Video',
        icon: <VideoIcon />,
        block: VIDEO,
      },*/
      custom_code: {
        name: 'CustomCode',
        block: CUSTOM_CODE,
      },
      textIcon: {
        name: 'Icona + Testo',
        block: TEXT_ICON,
      },
      ecosistemaMobilityImage: {
        name: 'Immagine Ecosistema Mobility',
        block: MOBILITY_IMAGE,
      },
    },
  },
  {
    title: 'Box',
    blocks: {
      simpleBox: {
        name: 'Box semplice',
        block: SIMPLE_BOX,
      },
      boxLink: {
        name: 'Box Link',
        block: BOX_LINK,
      },
      textImageBox: {
        name: 'Box Testo + Immagine',
        block: TEXT_IMAGE_BOX,
      },
      circleBox: {
        name: 'Box con cerchio',
        block: CIRCLE_BOX,
      },
      listImageBox: {
        name: 'Box con lista + immagine',
        block: LIST_IMAGE_BOX,
      },
      listIconBox: {
        name: 'Box Caratteristiche',
        block: LIST_ICON_BOX,
      },
      copertinaBox: {
        name: 'Copertina',
        block: COPERTINA_BOX,
      },
      rowIcons: {
        name: 'Riga Icone',
        block: ROW_ICONS,
      },
      textImageBoxWithIcons: {
        name: 'Box Testo + Immagine + Icone',
        block: TEXT_IMAGE_BOX_WITH_ICONS,
      },
    },
  },
]
